module.exports = __webpack_public_path__ + "static/media/CSVImportImage.b4a8b407.png";